// extracted by mini-css-extract-plugin
export default {"languagesButtonBox":"KnowledgeLang_languagesButtonBox__Cquh0"};